export default __webpack_public_path__ + "fonts/iconfont.fdf85fd9e67235668988bf4acd1ddb11.woff2";